import { ContactBlockCss } from '../../styles';
import { PLATFORM_LOGOS, PLATFORM_URLS_LINKSERVS, SocialPlatform, SOCIAL_PLATFORMS } from '../../utils/SocialConfig';

/**
 * 🟢 ContactoRedesSociales
 * Componente que muestra los iconos de redes sociales con enlaces a las plataformas correspondientes.
 * Cada icono es clickeable y abre la red social en una nueva pestaña.
 */
const ContactoRedesSociales: React.FC = () => {
  return (
    <div
      // Contenedor principal: fondo negro, texto blanco, padding y bordes redondeados
      className={`flex-1 bg-black text-white p-4 rounded-2xl shadow-2xl flex flex-col text-start justify-between ${ContactBlockCss.contacto}`}
      style={{ transform: 'none' }} // Se asegura que no haya transformaciones CSS activas
    >
      {/* Título */}
      <p className="font-semibold text-white">Síguenos en nuestras redes sociales:</p>

      {/* Contenedor de iconos, centrado y con separación entre ellos */}
      <div className="flex justify-center space-x-4 mt-2.5">
        {SOCIAL_PLATFORMS.map((platform: SocialPlatform) => (
          <a
            key={platform} // Clave única por plataforma
            href={PLATFORM_URLS_LINKSERVS[platform]} // URL correspondiente a la red social
            target="_blank" // Abrir en nueva pestaña
            rel="noopener noreferrer" // Seguridad: evita que la nueva pestaña acceda al window.opener
            aria-label={`Ir a ${platform}`} // Accesibilidad
          >
            <img
              src={PLATFORM_LOGOS[platform]} // Logo de la red social
              alt={platform} // Texto alternativo
              className="w-8 h-8 transition-transform transform hover:scale-125" // Tamaño y efecto hover
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default ContactoRedesSociales;
